import ITable from '../../main/interfaces/ITable';

export type TableWithLayout = ITable & {
  posX: number;
  posY: number;
};

export interface RoomCustomizationDto {
  id: number;
  code: string;
  name: string;
  isDefault?: boolean;
}

export interface TableLayoutDto {
  tableId: number;
  posX: number;
  posY: number;
}

const clamp = (value: number, min: number, max: number) => Math.min(max, Math.max(min, value));
const toFiniteNumber = (value: unknown) => {
  const numericValue = Number(value);
  return Number.isFinite(numericValue) ? numericValue : null;
};

export const RESTAURANT_SELECTED_ROOM_KEY = 'restaurantSelectedRoomId';

export const clampPercent = (value: number) => clamp(value, 0, 100);

export const initTablePositions = (data: ITable[]): TableWithLayout[] => {
  if (!data.length) return [];

  const rowsMap = new Map<number, ITable[]>();

  data.forEach((table) => {
    const key = table.rowId ?? 0;
    if (!rowsMap.has(key)) rowsMap.set(key, []);
    rowsMap.get(key)?.push(table);
  });

  const sortedRowIds = Array.from(rowsMap.keys()).sort((a, b) => a - b);
  const rowCount = sortedRowIds.length || 1;
  const result: TableWithLayout[] = [];

  sortedRowIds.forEach((rowId, rowIndex) => {
    const rowTables = rowsMap.get(rowId) ?? [];
    const tableCount = rowTables.length || 1;
    const yStep = 100 / (rowCount + 1);
    const y = yStep * (rowIndex + 1);

    rowTables.forEach((table, index) => {
      const xStep = 100 / (tableCount + 1);
      const x = xStep * (index + 1);

        result.push({
          ...table,
          posX: x,
          posY: y,
        });
      });
    });

  return result;
};

export const applyLayoutToTables = (tables: TableWithLayout[], layout: TableLayoutDto[]): TableWithLayout[] =>
  tables.map((table) => {
    const saved = layout.find((item) => item.tableId === table.id);

    if (!saved) return table;

    const savedPosX = toFiniteNumber(saved.posX);
    const savedPosY = toFiniteNumber(saved.posY);

    if (savedPosX == null || savedPosY == null) {
      return table;
    }

    return {
      ...table,
      posX: clampPercent(savedPosX),
      posY: clampPercent(savedPosY),
    };
  });

export const setDefaultRoomInList = (rooms: RoomCustomizationDto[], roomId: number | null, isDefault: boolean): RoomCustomizationDto[] => {
  if (!roomId) return rooms;

  return rooms.map((room) => {
    if (room.id === roomId) {
      return { ...room, isDefault };
    }

    return isDefault ? { ...room, isDefault: false } : room;
  });
};
